var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomOccupancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#C3E3F1;enable-background:new;}\n\t.st1{fill:#87C8E4;}\n\t.st2{fill:none;stroke:#87C8E4;stroke-width:2.5988;stroke-miterlimit:10;}\n\t.st3{fill:#C3E3F1;}\n\t.st4{fill:#43525A;}\n\t.st5{fill:#468EAD;stroke:#43525A;stroke-width:0.5717;stroke-miterlimit:10;}\n\t.st6{fill:#3E6D85;}\n\t.st7{fill:#468EAD;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:#E2EEF8;}\n\t.st10{fill:#3E6D85;stroke:#43525A;stroke-width:0.5717;stroke-miterlimit:10;}\n\t.st11{fill:#468EAD;stroke:#43525A;stroke-width:0.7623;stroke-miterlimit:10;}\n\t.st12{fill:#87C8E4;stroke:#43525A;stroke-width:0.7623;stroke-miterlimit:10;}\n\t.st13{fill:#49ABD7;}\n\t.st14{fill:#49ABD7;stroke:#43525A;stroke-width:0.5717;stroke-miterlimit:10;}\n\t.st15{fill:#49ABD7;stroke:#43525A;stroke-width:0.7623;stroke-miterlimit:10;}\n\t.st16{fill:#42515A;}\n\t.st17{fill:#FEC010;}\n\t.st18{fill:none;stroke:#FEC010;stroke-width:2.5988;stroke-miterlimit:22.93;}\n\t.st19{fill:none;stroke:#FEC010;stroke-width:2.5988;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 375,
    height: 302
  }), /*#__PURE__*/React.createElement("rect", {
    y: 260.2,
    className: "st1",
    width: 375,
    height: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 255.9,
    x2: 375,
    y2: 255.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.8,260.2c-5.1-25.7-3.8-41.6-3.8-41.8c0-0.2-0.7-0.8-1.1-0.8s-2.2-0.1-2.3,0.3c-0.2,0.3-1,19.6,5.8,42.3 H334.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.3,260.2c5.1-25.7,3.8-41.6,3.8-41.8c0-0.2,0.8-0.8,1.1-0.8c0.3,0,2.2-0.1,2.4,0.3 c0.3,0.3,0.6,20.6-5.3,42.3H293.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.1,260.2c5.1-25.7,3.8-41.6,3.8-41.8c0-0.2,0.8-0.8,1.1-0.8s2.2-0.1,2.4,0.3c0.3,0.3-0.3,21-5.3,42.3 H285.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M326.6,260.2c-5.2-25.7-3.9-41.6-3.9-41.8c0-0.2-0.7-0.8-1.1-0.8s-2.2-0.1-2.3,0.3c-0.2,0.3-0.5,20.7,5.2,42.3 H326.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.6,215.2h32.1c0-3.5,0.1-7.1,0.4-10.6c0.2-6.6,0.9-13.2,1.9-19.8c1.4-7.6,2.6-12.1,2.6-12.1 s2.8-3.5,8.5-3.4c5.7,0.1,5.1,3.7,5.1,3.7v0.3c-3.5,14.1-5.3,28.6-5.1,43.1v2.3c0,0.4-0.3,1.4-0.8,1.4h-44.7c-0.4,0-0.8-1-0.8-1.4 v-2.1C285.8,216.3,286.1,216,286.6,215.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.8,216.4c-0.1-6.1,0.3-12.3,1-18.4c0.8-7.8,2.2-15.5,4.3-23c0-0.1,0.1-0.2,0.1-0.3s0.5-3.5-5.2-3.6 s-8.3,2.6-8.5,3.2c-0.2,0.6-0.7,2.5-1.6,6.8c-0.3,1.4-0.7,3.1-1,4.9c-1,6.3-1.6,12.6-1.8,19c-0.5,5.1-0.7,9.4-0.2,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.2,216.4h-44.5c0,0,1-4.1,26.9-3.5C330.7,213.4,330.2,216.4,330.2,216.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M271.7,255.8c0.1,2.1-2.9,2.5-6.2,2.5s-2.4,0.8-7,1.5c-4.6,0.7-6.4-0.7-6.8-1.3c-0.3-0.6,1.9-1.4,4.2-2.3 l0.9-0.3c2.6-1,4.1-3.3,6.2-5.4c2.1-2.1,4.1-8.3,4.1-8.3l6.2-1.1c0,0-1.9,5.8-2.6,8.2c-0.3,1.5-0.1,3,0.4,4.3 C271.5,254.3,271.7,255.1,271.7,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.6,258.3c-3.4,0.1-2.4,0.8-7,1.5c-4.6,0.7-6.5-0.2-6.8-0.8c-0.3-0.6-0.3-1.4,4-2.8l1.6-0.4 c0,0,1.9,1.7,5.6,0.8c3.7-1,5.7-3.6,7.9-4.1c0.2,0.7,0.8,2.5,0.9,3.2C271.8,257.8,269,258.2,265.6,258.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315.1,198.8c0,0-35.9,2.4-41.7,6.2c-5.8,3.7-8.7,43.1-8.7,43.1c0.6,0.4,1.2,0.6,1.9,0.6 c1.5,0,3.1-0.2,4.6-0.5c0,0,10-17.8,10.9-22.7c1-4.9,3.5-9,5.6-9.2c2.2-0.2,28.2,1,32.2-6.2c4.1-7.2,1.7-12,1.7-12L315.1,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M276.2,257.9c-0.1,2.3-3.3,2.3-6.9,2c-3.6-0.3-2.6,0.6-7.7,0.8c-5.1,0.2-6.8-1.5-7.1-2.2 c-0.3-0.7,2.3-1.2,4.9-1.9l1-0.3c2.9-0.8,4.8-3,7.3-5s5.3-8.5,5.3-8.5l6.8-0.5c0,0-2.8,6-3.8,8.6s-0.3,3.3,0.1,4.8 C276.1,256.3,276.2,257.1,276.2,257.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269.2,259.9c-3.6-0.3-2.6,0.6-7.7,0.8c-5.1,0.2-6.8-1.5-7.1-2.2c-0.3-0.7,2.3-1.2,4.9-1.9l1.1-0.3 c0,0,2.3,1.3,6.5,0.8s6.3-2.8,8.7-3c0.3,1.3,0.5,2.6,0.6,3.9C276.1,260.1,272.9,260.2,269.2,259.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.2,199.7c0,0-29,2.9-34.7,6.8c-5.7,3.9-12,42.5-12,42.5c0.6,0.3,1.2,0.5,1.9,0.6c1.7-0.2,3.4-0.5,5.1-1 c0,0,9.4-18,10.6-22.9c1.1-4.9,1.6-9.1,3.8-9.4c2.2-0.3,28.2,1.8,32-5.5S316.2,199.7,316.2,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M324.5,163.9L324.5,163.9c-0.4-0.4-0.8-0.7-1.2-1l0,0v0.2l-4.2-2.9l0,0c-0.5-1.4-2.7-5.5-1-8.5l-3.5,2.2 l-6.8,1.8c0.3,1.3,0.6,2.6,0.7,4c0,0.4,0.6,1,0.6,1.4l-1.3,0.4v-0.2l0,0c0,0-3.3,0.3-4.2,1.3c-0.9,1-3.3,7.6-3.7,8.7l25.9,0.4 C325.9,171.8,326.3,166.1,324.5,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289,193.1l4.5,5.6c0.1,0.3,0.3-1.2,0.5-1c0.3,0.3,1.8-4,2.9-3.6c0.4,0.2,0.8,0.2,1.2,0.1 c1-0.3,1.8-0.9,2.5-1.7c0.8-0.8,1.6-1.7,2.3-2.6l0.6-1c0,0.3,0,0.5,0.1,0.8l0,0c0.2,1,0.1,2-0.1,2.9c-0.6,0.8-1.4,1.4-2.3,1.8 c-2,1.2-2.9,5.2-2,6.2s3.1,0.5,5.4,0.5c1.3-0.1,2.5,0.1,3.7,0.5h0.2c3.5,2.1,10.8,6.9,13.9,6.7c1.1-0.2,2.5-1.9,1.7-5 c-1.1-4.9-2.2-11.5-2.2-14.4c0-2.9,3.6-17.4,3.6-17.4s0.6-5.6-1.2-7.8l-1-1.1l-0.5-0.3h-1.1c-2.7,0.7-6.6,4.2-11.2,4.5 c-4.6,0.3-7.3-4.2-7.3-4.2s-3.1,7.3-3.6,8.4c-0.4,1.1-3.7,14.6-4.7,15.4S288.5,192.7,289,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.8,155.6c0.4,1.3,0.6,2.7,0.7,4.1c3.8-0.3,5.3-3.9,6.1-5.9L307.8,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.3,157.7c0,0,14-0.5,13.8-10.6c-0.3-7.4-1.7-13.1-9.3-13c-7.5,0.1-8.8,6.3-9.3,8.7 C301.1,145.3,303.3,157.6,306.3,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.4,189.1c0,0-5.6-1.3-7.4-0.8c-1.8,0.5-5.7,3.9-4.8,3.9h5.4c0.7,0,4.4,0.1,6.2-0.1 C310.6,192,309.4,189.1,309.4,189.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M325.1,164.2c0,0,3.1,8.9,4.3,14.2c0.8,3.5,2.1,5.8,2.4,8.1s-2.5,5.7-5.2,5.7h-5.1c-6.2-0.2-14.2-0.1-14.2-0.1 s-0.1-3,1.1-4.2c1.2-1.2,3.1-1.1,6.8-0.9c3.6,0.3,7.8-1.6,7.8-1.6l-4.4-17L325.1,164.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "294.6,192.2 263.9,192.2 258.5,173 289.1,173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "263.7,190.8 304.1,190.8 304.1,192.3 263.9,192.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.5,182.3c-0.2-0.5,0.1-1.1,0.6-1.3c0.1,0,0.3-0.1,0.4-0.1c0.8,0,1.6,0.6,1.8,1.4c0.2,0.5,0,1.1-0.5,1.4 c-0.1,0.1-0.3,0.1-0.4,0.1C274.5,183.7,273.8,183.1,273.5,182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M335.5,196.9l1.8,10.1l0,0l4.9,27.9l4.4,24.9c0,0.4,0.4,0.7,0.8,0.6c0,0,0,0,0,0c0.3,0,0.5-0.2,0.5-0.5 c0,0,0-0.1,0-0.1l-3.7-28.2l-4.1-30.3l-0.6-4.5L335.5,196.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.1,197.9h146c1.5,0.1,2.8-1.1,2.9-2.6c0-0.1,0-0.2,0-0.3l0,0c0.1-1.5-1.1-2.8-2.7-2.9c-0.1,0-0.2,0-0.3,0 h-146c-1.5-0.1-2.8,1.1-2.9,2.6c0,0.1,0,0.2,0,0.3l0,0c-0.1,1.5,1.1,2.8,2.7,2.9C199.9,197.9,200,197.9,200.1,197.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.7,177.1c0.8,1.7,1.9,3.3,3.1,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.8,179.8c0.3,1,0.8,2,1.5,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M318.1,208.5c-1.2,1.3-1.7,3-1.5,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M321.5,208.4c-0.7,1.2-1.8,2.1-3.2,2.4c-0.4,0.2-0.8,0.4-1.3,0.4l-8.7,1.6c-0.8,0.2-1.7,0.3-2.6,0.2 c-1.2-0.3-2.3-1.2-3.6-1.1c-1.3,0.1-2.6,1.6-4,1.6c-0.6-0.2-1.1-0.3-1.7-0.3c-0.8,0.1-1.4,0.9-2.1,0.6c-0.7-0.3-0.6-0.5-1-0.6 l-0.8,0.3c-1,0.6-2.2,0.6-3.2,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.9,211.2c1,1.2,1.7,2.6,1.8,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.6,212c1.2,1.5,2.2,3.3,2.7,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287,214.5c-0.1,4.1-0.1,8.1-1.9,11.7c-0.7,1.3-1.2,2.7-1.9,4c-0.7,1.3-1,2.3-1.9,3.3 c-0.5,0.4-0.9,0.7-1.3,1.1c-0.4,0.7-0.7,1.4-0.8,2.2c-0.8,2.9-4.2,9.1-5.1,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.9,205.7c-2.4-0.2-4.4-1.8-6.4-3c-2.6-1.4-5.4-2.3-8.3-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M321.5,203.9c-1.9-0.9-3.9-1.4-5.9-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.1,154c-1.3,1.8-4.4,2.9-6.6,3.2c-0.6,0.1-1.2,0-1.7-0.3c-0.3-0.2-0.5-0.5-0.7-0.8 c-1.4-2.7-2.2-5.6-2.1-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.5,157.2c0.8,0.6,0.9,1.8,1.2,2.8c0.5,0.8,1.1,1.6,1.9,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309,161.2c-0.7,0.2-1.4,0.3-2.2,0.3c-0.8-0.1-1.5-0.1-2.3,0.2c-1,0.4-1.6,1.6-2.1,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.6,162.3c-3.6,0.4-6.3,3.5-9.8,4.4c-3.6,0.8-7.4-0.7-9.4-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M325,164.2c3.1,5.9,3.6,12.7,5.8,19c0.4,0.9,0.7,1.8,0.9,2.8c0.2,2.9-1.6,5.4-4.4,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320.3,170.8c-0.5,1.8-0.4,3.8,0.3,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M321.9,172c-0.6,1.6-0.9,3.4-0.8,5.1c0.1,0.3,0.1,0.6,0,0.9c0,0.2-0.1,0.4-0.1,0.7c0.1,0.4,0.2,0.7,0.4,1 c0.6,1,0.9,2.2,0.9,3.4c0,0.8-0.1,1.9,0.7,2.2h0.8c1.4,0,2.6,0.9,2.9,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M324.9,188c-0.1-0.9-0.6-1.7-1.4-2.1c-0.8-0.5-1.7-0.5-2.5-0.1l-1.4,0.9c-0.9,0.4-1.9,0.5-2.9,0.4h-4.1 c-1.7,0-3.7,0.1-4.9,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303,167.1c0.2,0.8,0.3,1.7,0.2,2.6c-0.1,0.6-0.3,1.3-0.5,1.9c-0.5,2-0.4,4.2,0.4,6.2c0.5,1,0.9,2.2,1.2,3.3 c0.1,0.8,0,1.6-0.2,2.4l-0.7,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.8,188.6c-0.6,1.1-0.9,2.3-0.6,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M276.4,248.5c-1,0.5-2.1,0.8-3.2,0.9l-2.3,0.2c-0.5,0.1-1.1-0.2-1.4-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182.8,135.7h-1.1 M201.8,192.4h-47.6l4.9-19.3h-27.1l-4.4,15.1c-0.4-0.9-0.9-1.8-1.5-2.7 c0.4-2.5-2.4-4.7-2.4-4.7s-1.6-4.9-1.7-6.2c-0.6-3.1-0.7-11.4-4.5-13.8c-3.8-2.3-8.5-4.5-9.4-6.2c4.8-1,6.1-6.7,5.6-11.5 c0.2-0.3,1.8-4.6-0.2-6.9c-0.3-0.4-0.7-0.7-1.1-1l-0.5-0.4c-0.4-1.1-1.1-2.2-2-2.9c-1.2-0.6-2.6-0.8-3.9-0.8l-1.3,0.2 c-9.3-3.6-11.6,9.3-11.3,12.4s3.9,5.7,1.7,10.7c-0.3,0.8-2.2,1.5-2.3,2.3s-3.1,2.3-3.7,3.8c-0.2,0.6-0.4,1.2-0.6,1.8 c-1.2,2.9-1.6,6.6-2.7,10.5c-1.3,3.3-2,6.8-2.3,10.4c-0.4,3.3-0.6,8.1-0.1,9.4H67.1c-1.1,0-1.9,0.9-1.9,1.9v1.4 c0,1.1,0.9,1.9,1.9,1.9h8l-0.3,1.6l-4.1,38.5l-3,22.9c-0.1,0.4,0.3,0.6,0.6,0.7c0.3,0.1,1.9-0.3,2-0.7l3-23.5l5.9-33.9l1-5.7h5.6 c0,0.4,0,0.9,0.2,1.3c0.2,0.6,0.7,1.1,1.3,1.3c0.2,3.8,1.7,7.3,4.3,10c0.9,0.8,2,1.4,3.2,1.6v3.4l0,0c0,0.3,0.3,0.5,0.6,0.5h0.5 v0.2c0,0.2,1.4,16.9-4,44.3h1c7.4-22,7.1-41.2,6.8-44.4h4.9v0.2c0,0.2,1.4,16.9-4,44.3h1c7.4-22,7.1-41.2,6.8-44.4h12 c-2,9.3-3,20.2-3,20.2l0.8,0.4c-0.6,2.3-1.4,4.6-2.2,5.3c-0.4,0.3-0.9,0.6-1.5,0.7l0,0l-1.3,0.5l-0.3,0.2c-0.5,0.3-0.9,0.7-1.3,1.1 c-0.4,0.4-0.5,1-0.3,1.5l0,0c0.3,1,1.6,2.1,3,3.3l0.4,0.3h0.2c1.4,1.2,0.9,1.5,3.2,4c2.3,2.5,4.6,2.9,5.1,2.6h0.1 c0.2-0.3-0.5-1.6-1.3-2.9c-0.3-0.4-0.6-0.9-0.9-1.4c-1.1-1.9-0.8-2.9-0.5-5.9c0.5-2.8,1.2-5.5,2.1-8.1h0.7l4.3-11.7 c0.7,11.6,3,23.1,6.7,34.2h1c-5-25.6-4.2-41.9-4-44.1c1.5,1.9,3.1,3.6,4.8,5.3c0.3,13.2,2.6,26.3,6.8,38.8h1 c-2.3-11.6-3.7-23.3-4.1-35.1c4.8,4.6,9.4,8.7,9.4,8.7h0.2l1.3,2.1c0.5,1,0.7,2.2,0.6,3.3h-0.1c0,0.8,0,1.6,0,2.3v0.2 c0.1,0.1,0.1,0.3,0.1,0.4c0.4,1.9,3.2,1.6,6.3,0.9c3.1-0.8,2.3,0.2,6.8-0.3c4.4-0.5,5.8-2.2,6-2.8c0.2-0.6-2.1-0.9-4.4-1.1h-1 c-2.7-0.3-4.6-2.1-7-3.5c-1-0.8-1.9-1.7-2.7-2.7l0.2-0.2c0,0-11.6-23-20-34.7h89.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.6,96.9c5,0.7,13.6,3.6,20.4-5.5c5.2-6.8,4.2,1,12.6-3.6c5.3-2.8,8.8-6,16.2,4.5 c7.4,10.5,24.1,12.7,24.1,12.7s-9.9-1-17.4-13.1s-15.9-22.4-18.1-19.1s-10.4-9.8-15.9-8.9c-5.5,0.9-8.3,6-7.9,11.8 c0.4,5.8-7.4,2.7-12.9,5.1C135.2,83.3,128.6,95.1,139.6,96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.5,84.2c1.1-1,9.4-6.9,7.1-9.2c-2.3-2.3-4,5.9-11.7,3.2C96.2,67.3,116.8,97.1,131.5,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123,66.7c-8.7-3.6-7.4-7.4-10.2-14.6c-2.8-7.2-9.9,4.9-3,13.9C119.2,78.4,129.9,69.6,123,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98,59.8c6.1,3.6,5.4-9.2,1.1-11.4C94.9,46.1,92.2,56.3,98,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.2,42.3c6.9-1.2-0.3-9-4.9-8.1C83.8,35.2,86.5,43.4,93.2,42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M172.3,62.5c-19.9-14.3-26.6-3.4-20.9,8.3c-2.8-9.5,2-20.6,20.6-6.6l0.4,0.3c0.3-0.2,1.9-2.9,5.1-3.3 c9.6-1.6,17.6,24.7,26.2,31.7C194.2,83.1,184.7,48.6,172.3,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.3,47.3C84,60,93.2,65,98.3,64.5c2.1,0,4.2,0.9,5.6,2.5c8.3,9.4-13.8,25.5,22,25 c-40.6,8.5-9.5-24.6-27.5-26l0,0C90.9,66.6,83.4,58.3,90.3,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.2,262c-1.2,0-1.3-0.3-1.4-0.8l-3.6-25.4l-6.4-36.5l-1.8-10.2h4.6l0.8,5.9l5.6,41.7l3.3,24.6 C190.4,261.6,189.6,262,189.2,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,261.4c5.9-29.5,4.4-47.5,4.3-47.7c-0.1-0.3,0.9-0.9,1.3-0.9s2.5-0.2,2.8,0.3s1,22.3-6.7,48.3H48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.2,261.4c-5.9-29.5-4.4-47.5-4.4-47.7c0-0.3-0.8-0.9-1.2-0.9s-2.5-0.2-2.8,0.3c-0.3,0.4-0.8,23.6,6,48.3 H96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.7,261.4c-6-29.5-4.4-47.5-4.4-47.7c0-0.3-0.9-0.9-1.3-0.9c-0.4,0-2.5-0.2-2.7,0.3s0.3,24,6,48.3H105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.2,261.4c5.9-29.5,4.4-47.5,4.4-47.7c0-0.3,0.8-0.9,1.3-0.9s2.4-0.2,2.7,0.3s0.6,23.6-6,48.3H58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104,209.9H67.3c0.1-4-0.1-8-0.5-12c-0.2-7.5-1-15.1-2.2-22.5c-1.6-8.8-2.9-13.9-2.9-13.9 c0-0.1-3.1-3.9-9.7-3.8c-6.6,0.1-5.9,4.2-5.9,4.2s0,0.3,0.1,0.3c4,16.1,5.9,32.7,5.8,49.3c-0.1,0.1-0.1,0.2-0.1,0.3v2.4 c0,0.5,0.4,1.6,0.9,1.6H104c0.4,0,0.9-1,0.9-1.6v-2.4C104.8,211.2,104.4,210.8,104,209.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.5,211.4c0.1-7-0.3-14.1-1-21c-0.9-8.9-2.6-17.7-4.9-26.3c-0.1-0.1-0.1-0.2-0.1-0.3s-0.6-4,5.9-4.1 c6.5-0.1,9.5,2.9,9.7,3.7c0.2,0.8,0.8,2.8,1.8,7.7c0.3,1.6,0.8,3.6,1.1,5.6c1.2,7.2,1.9,14.5,2.2,21.7c0.5,5.8,0.8,10.7,0.2,13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,211.4h50.8c0,0-1.2-4.8-30.6-4C53.4,207.8,54.1,211.4,54.1,211.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.9,126c0,0-0.4-5.4-8.1-4c-2,0.3-3.4-3.2-6.8-1.9c-7.1,2.8-7.5-1-9.6,4.2c-0.9,2.1-6.3,4.6-4.7,8.3 c1.6,3.7-1.1,6.2,0.9,9.2c1,1.5,0.6,4.2,5.4,4.2c2.4,0.1,6.2,4.5,8.8,5.4c2.7,0.9,10.8-0.4,10.5-4.1c-0.3-3.6,3.1-2.7,5.2-6 s-1.4-3.6,0.3-8.3C90.5,128.5,86.7,128.9,86.9,126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.9,256.4c-0.2,2.3,3.2,2.9,7,2.9c3.8,0,2.8,0.9,8.1,1.6s7.3-0.8,7.6-1.5c0.3-0.7-2.2-1.6-4.8-2.6l-1-0.3 c-2.9-1.2-4.7-3.7-7.1-6.2c-2.4-2.4-4.6-9.5-4.6-9.5l-7.2-1.2c0,0,2.3,6.6,3.1,9.4c0.3,1.7,0.1,3.4-0.6,5 C121.1,254.8,121,255.6,120.9,256.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.9,259.3c3.8,0.1,2.7,0.9,8,1.6c5.3,0.8,7.4-0.2,7.8-0.9s0.5-1.6-4.5-3.1l-1.8-0.6c0,0-2.3,2-6.5,1 c-4.2-1-6.6-4.1-9-4.7c-0.4,1.2-0.8,2.5-1,3.7C120.8,258.7,124.1,259.2,127.9,259.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.3,192.1c0,0,37.6,1,44.3,5.3c6.7,4.2,13.3,50.1,13.3,50.1c-0.7,0.4-1.4,0.6-2.2,0.7 c-1.4,0.2-5.3-0.6-5.3-0.6S110,227.2,109,221.7c-1-5.5-4.1-10.4-6.5-10.5c-2.4-0.1-32.1,1-36.8-7.2c-4.7-8.2-2.1-13.7-2.1-13.7 L71.3,192.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.8,258.8c0.2,2.6,3.8,2.7,7.9,2.3s3,0.6,8.8,0.9c5.8,0.3,7.8-1.6,8.1-2.5c0.3-0.9-2.5-1.4-5.5-2.2 l-1.1-0.3c-3.4-1-5.5-3.5-8.3-5.7s-6.1-9.8-6.1-9.8l-7.9-0.5c0,0,3.2,6.8,4.3,9.7c1.1,2.9,0.3,3.9,0,5.5 C116,256.9,115.8,257.8,115.8,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.7,261.1c4.2-0.4,3,0.6,8.8,0.9c5.8,0.3,7.8-1.6,8.1-2.5c0.3-0.9-2.5-1.4-5.5-2.2l-1.4-0.4 c0,0-2.7,1.6-7.4,1c-4.7-0.6-8.1-3.3-10-3.5c-0.3,1.5-0.6,2.9-0.7,4.4C116,261.4,119.6,261.4,123.7,261.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.1,192.2c0,0,33.2,3.3,39.8,7.8s13.7,48.6,13.7,48.6c-0.6,0.4-1.4,0.6-2.2,0.6c-1.4,0.1-5.8-1-5.8-1 s-10.8-20.6-12.1-26.2c-1.3-5.5-1.8-10.4-4.2-10.7c-2.4-0.3-32.3,2.1-36.6-6.3S70.1,192.2,70.1,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.6,151.3L60.6,151.3l1.5-1l0,0c2.1-1.4,4.3-2.5,6.7-3.3l0,0c0.6-1.6,2.5-5.6,2.8-9l0.4,1.8l7.7,2.1 c-0.4,1.5-0.6,3-0.8,4.5c0,0.5-0.7,1.2-0.7,1.6l1.5,0.5v-0.3l0,0c0,0,3.7,0.4,4.8,1.6s3.7,8.7,4.2,10l-29.5,0.5 C59.2,160.3,58.5,153.9,60.6,151.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.3,184.8c-0.2,0.2-5.3,5.9-5.2,4.7c0.1-1.2-0.3,0.3-0.6,0.6c-0.3,0.3-2.2-4.5-3.4-4.1 c-0.4,0.2-0.9,0.2-1.4,0.2c-1.1-0.5-2.1-1.2-2.9-2.1c-0.9-0.9-1.8-1.8-2.5-2.9l-0.7-1.3c0,0.3-0.1,0.7-0.1,1l0,0 c-0.2,1.1-0.2,2.2,0.1,3.3c0.7,0.9,1.5,1.6,2.5,2.1c2.3,1.4,3.4,5.9,2.4,7.1c-1,1.2-3.6,0.6-6.2,0.6c-1.4-0.1-2.9,0.1-4.2,0.7h-0.3 c-3.9,2.3-12.3,7.9-15.9,7.5c-1.4-0.1-2.9-2.2-2.1-5.6c1.4-5.5,2.5-13.2,2.5-16.5c0-1.8-4.1-19.8-4.1-19.8s-0.8-6.4,1.4-9l1.1-0.3 l0.6-0.3l1.2-0.9c3.2,0.8,7.6,4.9,12.8,5.2c5.2,0.3,8.4-4.8,8.4-4.8s3.5,8.3,4,9.6c0.5,1.3,4.3,16.8,5.4,17.7 S101.8,184.2,101.3,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.7,141.8c-0.4,1.5-0.6,3.1-0.8,4.7c-4.4-0.4-6.1-4.5-6.9-6.8L79.7,141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,144.1c0,0-10.1-0.8-9.7-7.2c0.4-6.4-0.8-10.6,5.8-10.5s7.7,2.6,8.1,4.8C85.7,133.3,83.7,144.1,81,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.7,124.4c-3.1-0.3-4.2-0.1-4.2,0.9l-0.6-0.8c-1-0.7-3.9-1.4-6.9-0.9c-3,0.5-3.4,13.7-2.6,13.6 c0.9,0,1.6-0.7,1.6-1.6c0.1-1,2.1-1.9,1.9-3.2c-0.2-1.3,0.1-1.6,2-1.5s1.6-1.1,2.4-2.3c0.8-1.2,2.3-1.1,3.1-1 c1.1,0.4,2.1,1.2,2.7,2.2c0.6,0.8,1,1.8,1,2.8c0,0.4-0.1,0.8-0.2,1.1C85,133.8,89.7,125,84.7,124.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.8,180.1c0,0,6.5-1.5,8.6-0.8c2.1,0.7,6.5,4.4,5.5,4.4h-6.2c-0.8,0-5,0.1-7-0.1 C76.6,183.5,77.8,180.1,77.8,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.9,152.5c0,0-3.6,9.5-4.9,15.5c-1,4-2.5,6.6-2.9,9.2s2.9,6.6,6,6.6h22.1c0,0,0.1-3.4-1.3-4.9 c-1.4-1.5-3.6-1.3-7.8-0.9s-8.8-2.2-8.8-2.2l5-19.3L59.9,152.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "94.8,183.7 129.8,183.7 136.1,161.7 101.1,161.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "130,182.1 83.9,182.1 83.9,183.8 129.8,183.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.8,172.4c0.2-0.6-0.1-1.3-0.7-1.6c-0.1-0.1-0.3-0.1-0.4-0.1c-1,0-1.9,0.7-2.2,1.6 c-0.2,0.6,0.2,1.3,0.8,1.5c0.1,0,0.3,0.1,0.4,0C117.7,173.9,118.5,173.3,118.8,172.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,189l-2.1,11.6l0,0l-5.6,31.9l-5,28.5c-0.1,0.4-0.4,0.7-0.9,0.8c-0.4,0-0.8-0.3-0.7-0.7l4.3-32.4l4.7-34.6 l0.7-5.2L48,189z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.8,190.2H26.3c-1.7,0.1-3.2-1.1-3.4-2.8c0-0.1,0-0.2,0-0.4l0,0c-0.1-1.7,1.2-3.2,2.9-3.3 c0.1,0,0.3,0,0.4,0h176.5c1.7-0.1,3.2,1.2,3.3,2.9c0,0.1,0,0.2,0,0.4l0,0c0.1,1.7-1.2,3.1-2.8,3.2 C203.1,190.2,202.9,190.2,202.8,190.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,166.4c-1,1.9-2.2,3.7-3.6,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.7,169.4c-0.3,1.2-0.8,2.2-1.6,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.9,202.3c1.3,1.5,1.9,3.5,1.7,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.1,202.2c0.8,1.7,2.2,2.3,3.6,2.9c0.5,0.2,1,0.4,1.6,0.4l9.9,1.8c1,0.2,2,0.3,3,0.2c1.3-0.3,2.6-1.4,4-1.2 c1.4,0.2,2.9,1.8,4.6,1.6c0.7-0.1,1.3-0.2,2-0.3c0.9,0.2,1.6,1,2.3,0.8s0.8-0.7,1.2-0.7s0.6,0.2,0.9,0.3c1.2,0.6,2.5,0.7,3.7,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.4,205.4c-1.2,1.3-1.9,3-2.1,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104,206.3c-1.4,1.8-2.4,3.8-3,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.5,209.2c0.1,4.6,0,9.3,2.2,13.3c0.8,1.5,1.4,3,2.2,4.6c0.8,1.6,1,2.7,2.1,3.6s1.1,0.9,1.6,1.4 c0.5,0.7,0.8,1.6,1,2.4c0.9,3.4,4.7,10.4,5.8,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.4,199.1c2.8-0.2,5-2.1,7.4-3.5c2.9-1.6,6.1-2.6,9.4-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.1,197.1c2.1-1,4.3-1.7,6.7-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.5,140.1c1.4,2,5,3.4,7.5,3.6c0.7,0.2,1.4,0.1,2-0.3c0.3-0.3,0.5-0.6,0.7-1c1.6-3,2.7-6.5,2.4-9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80,143.7c-0.9,0.7-1,2.1-1.4,3.1c-0.5,1-1.3,1.9-2.2,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.3,148.2c0.8,0.2,1.7,0.4,2.5,0.4c0.8-0.1,1.7-0.1,2.5,0.2c1.2,0.5,1.8,1.8,2.3,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.7,151.3c4.1,0.4,7.3,2.3,11.3,3.3c4.1,1,8.5-0.7,10.8-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,153.4c-3.6,6.7-1.2,14.1-3.8,21.2c-0.4,1-3.7,0.9-3.9,1.9c-0.2,3.3,1.9,6.3,5.1,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.3,159.2c0.6,2.1,0.4,4.3-0.4,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.5,160.6c0.7,1.8,1,3.8,0.9,5.8v1c0.1,0.2,0.2,0.5,0.2,0.8c0,0.4-0.2,0.9-0.5,1.2c-0.7,1.1-1,2.5-1,3.8 c0,1,0.1,2.2-0.9,2.5h-0.9c-1.5,0.1-2.9,1.1-3.3,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,178.8c0.1-1,0.8-1.9,1.6-2.3c0.9-0.5,2-0.5,2.9-0.1l1.6,1c1,0.5,2.2,0.7,3.4,0.5h4.6 c2.1-0.1,4.3,0,5.6,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.2,155c-0.3,1-0.3,2-0.3,3c0.2,0.7,0.4,1.5,0.7,2.2c0.6,2.3,0.4,4.7-0.5,6.9c-0.6,1.2-1.1,2.5-1.4,3.9 c-0.1,0.9-0.1,1.8,0.2,2.7l0.8,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.7,179.6c0.7,1.2,1,2.7,0.7,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.6,248.1c1.1,0.5,2.4,0.9,3.6,1c0.6,0.1,1.2,0.2,1.8,0.3c0.9-0.1,1.7-0.3,2.5-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.4,122.9h-1.3 M276.2,248.4l0.5-0.4c1.6-1.2,2.9-2.5,3.4-3.6l0,0c0.2-0.6,0.1-1.2-0.3-1.6 c-0.4-0.5-0.8-0.9-1.4-1.2l-0.4-0.3l-1.5-0.6l0,0c-0.6-0.2-1.1-0.4-1.6-0.8c-0.9-0.7-1.7-3.3-2.4-5.7l0.9-0.6c0,0-1.1-12-3.3-22.2 h13.2c-0.3,3.5-0.8,24.8,7.4,49h1.1c-6-30.2-4.4-48.7-4.4-48.9h5.5c-0.4,3.5-0.8,24.8,7.4,49h1c-5.9-30.2-4.4-48.7-4.4-48.9h0.6 c0.4,0,0.6-0.3,0.7-0.6l0,0v-1.5c0-0.2,0-0.3-0.1-0.4V207c1.3-0.2,2.6-0.8,3.6-1.7c2.9-3.1,4.6-7,4.9-11.2c0.7-0.2,1.2-0.7,1.4-1.4 c0.2-1.1,0.3-2.1,0.3-3.2h6.2l1.1,8.1l6.6,37.3l3.4,26c0,0.4,0.9,1.1,2.2,0.8c0.4-0.1,0.7-0.4,0.7-0.8l-3.5-25.3l-4.4-42.6 l-0.3-3.6h17.4c1.1,0,2.1-0.9,2.1-2.1V185c0-1.1-0.9-2.1-2.1-2.1h-28.3c0.5-1.5,3.4-1.3,1.5-7.8c-1.2-4.1-1.9-7.5-3.3-11.5 c-1.4-4-1.7-8.5-3-11.6c-0.2-0.6-0.4-1.3-0.7-2c-0.3-0.7-4.4-6.1-7.9-6.3c-0.1-0.8,3.6-2.4,3.9-3.3c1.2-4.6-0.9-4.4-0.7-7.9 c0.2-3.5-1.4-17.8-11.6-13.8l-1.5-0.2c-1.5-0.1-2.9,0.1-4.2,0.8c-1.1,0.5-1.9,1.3-2.3,2.4l-0.6,0.5c-0.5,0.3-0.9,0.7-1.2,1.1 c-2.2,2.6-0.4,7.3-0.3,7.7c-0.4,5.3,0,12,4.2,13.6c-1.5,0.2-7.4,1.1-9.3,4.2c-2.9,5.1-3.5,13.6-4.1,17.1c-0.3,1.5-2,6.8-2,6.8 s-3.1,2.3-2.6,5.2c-0.7,0.9-1.2,1.9-1.6,2.9l-4.9-16.6h-30l5.4,21.3 M253.2,191.4c-9.3,13.1-22,38.5-22,38.5l0.2,0.2 c-0.9,1.1-1.9,2.1-3,2.9c-2.7,1.6-4.9,3.5-7.7,3.8h-1c-2.6,0.3-5,0.6-4.9,1.2c0.1,0.6,1.6,2.6,6.6,3.1s4.1-0.4,7.5,0.3 c3.5,0.8,6.5,1.2,6.9-1c0-0.1,0.1-0.3,0.1-0.4v-0.3c0.1-0.9,0.1-1.7,0-2.6h-0.1c-0.1-1.2,0.2-2.4,0.7-3.6c0.3-0.6,0.9-1.5,1.5-2.3 h0.2c0,0,5.1-4.6,10.4-9.7c-0.4,13-1.9,26-4.5,38.8h1.1c4.6-13.8,7.1-28.3,7.5-42.9c2.1-2.2,4-4.2,5.3-5.8 c0.1,2.4,1.1,20.4-4.5,48.7h1.1c4.1-12.2,6.6-24.9,7.4-37.8l4.9,12.9h0.8c1,3.6,2.2,7.6,2.3,9c0.3,3.3,0.6,4.3-0.6,6.5l-1,1.6 c-1,1.6-1.6,2.9-1.4,3.2l0,0c0.6,0.3,2.7,0.3,5.6-2.9c2.9-3.1,2.1-3,3.6-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M144,262.7c2.6,0.3,5.4,0.1,8,0.2h20.8c1.3,0.1,2.7,0,4-0.1c0.2-0.1,0.3-0.4,0.2-0.6c0-0.1-0.1-0.2-0.2-0.2 c-1.2-0.1-2.5-0.1-3.7-0.1h-20.6c-2.8-0.1-5.5-0.1-8.3,0.1c-0.3,0-0.3,0.4-0.1,0.4V262.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M126.2,177.2l-2.4,13.4l0,0l-6.5,37.2l-5.9,33.3c-0.1,0.5-0.5,0.9-1,0.9c-0.5,0-0.9-0.3-0.8-0.8l5-37.8 l5.5-40.4l0.8-6.1L126.2,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207,198.7c0,0-10.7,5.3-11.3,11s1.6,40.5,1.6,40.5s11.3,2.1,13.3,0c0,0,0.3-45.5-0.2-47.1 c-0.5-1.6,33.3-2.4,36-2.4L207,198.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.7,250.4c0,0,1.8,11.4-0.4,11.5l-13.9,0.3h-14.2c0,0,0.1-3.4,4.2-4.2s11.1-3.6,13.6-9.1 C201.5,243.4,209.7,250.4,209.7,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M266,262.5c-7.6-35.5-5.6-57.3-5.6-57.5c0-0.3-1.1-1-1.6-1.1c-0.5-0.1-3.3-0.1-3.6,0.3 c-0.3,0.4,0.5,29,7.7,58.3H266z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.6,262.5c7.6-35.5,5.6-57.3,5.6-57.5c0-0.3,1.1-1,1.6-1.1c0.5-0.1,3.3-0.1,3.6,0.3 c0.3,0.4,0.8,28.6-7.7,58.3H204.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M146.9,129.6l-3.3,39.2c0,0-0.3,2.4,1.5,2.4h14.5c0,0-2.3-0.5-2.2-1.6s3.8-40.4,3.8-40.4L146.9,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M160.5,170.6H146c-1.3-0.1-1.5-1.1-1.5-1.8v-1.6l0.3-2.6l0.2-2.3l0.3-2.9l0.2-2.5l2.3-27.9l14.3-0.3l-2.6,28.2 c-0.2,1.3-0.3,2.6-0.4,3.8c0,0.3,0,0.7-0.1,1c-0.1,1.2-0.1,2.2-0.3,3.1c-0.1,0.4-0.1,0.9-0.1,1.3c-0.2,1.6-0.3,2.7-0.3,2.9v0.3 C158.6,170.5,160.3,170.6,160.5,170.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "112.2,108.9 120.2,141.2 121.4,145.6 125.1,160.6 194.6,160.6 180.9,108.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "112.2,108.9 110.6,110.1 123.6,161.7 125.1,160.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "123.6,161.7 192.7,161.7 194.6,160.6 125.1,160.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 170.6,
    className: "st6",
    width: 17,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "191.3,151.1 180,109.6 112.1,109.6 112.1,108.9 180.9,108.9 192.1,151  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "159,161.6 159,162.2 144.9,164.9 145.1,162.7 145.2,161.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M161.7,155.8c-0.2-1.1-1.2-1.8-2.3-1.8c-0.8,0-1.5,0.6-1.5,1.4c0,0.1,0,0.3,0,0.4c0.3,1,1.2,1.8,2.3,1.8 c0.8,0,1.5-0.6,1.5-1.4C161.8,156,161.8,155.9,161.7,155.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "187.1,148.2 126.3,148.2 119.4,120.8 118.8,118.7 118.4,116.9 117.6,113.8 177.7,113.8 178.4,116.9  179,118.7 179.6,120.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "178.4,116.9 118.4,116.9 117.6,113.8 177.7,113.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.5,126.3h-9.1c-0.3,0-0.6-0.2-0.7-0.5l0,0c-0.1-0.3,0.1-0.4,0.4-0.4h9.1c0.3,0,0.6,0.2,0.7,0.4l0,0 C135,126.1,134.9,126.3,134.5,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,128.3h-9.2c-0.3,0-0.5-0.2-0.6-0.5l0,0c-0.1-0.2,0-0.4,0.1-0.5c0.1,0,0.1-0.1,0.2,0h9.2 c0.3,0,0.6,0.2,0.7,0.5l0,0C135.5,128,135.3,128.3,135,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.6,130.3h-9.2c-0.3,0-0.6-0.2-0.7-0.5l0,0c0-0.3,0.2-0.5,0.4-0.5h9.2c0.3,0,0.6,0.2,0.6,0.5l0,0 c0.1,0.2,0,0.4-0.1,0.5C135.7,130.3,135.6,130.3,135.6,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151,126.3h-9.2c-0.3,0-0.6-0.2-0.7-0.5l0,0c0-0.2,0.2-0.4,0.4-0.4h9.2c0.3,0,0.5,0.2,0.6,0.4l0,0 C151.4,126.1,151.2,126.3,151,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.4,128.3h-9.2c-0.3,0-0.5-0.2-0.6-0.5l0,0c0-0.2,0.1-0.5,0.3-0.5c0,0,0.1,0,0.1,0h9.1 c0.3,0,0.6,0.2,0.7,0.5l0,0C151.9,128,151.8,128.2,151.4,128.3C151.5,128.3,151.5,128.3,151.4,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.9,130.3h-9.2c-0.3,0-0.5-0.2-0.6-0.5l0,0c-0.1-0.3,0.1-0.5,0.3-0.5h9.2c0.3,0,0.6,0.2,0.6,0.5l0,0 c0.1,0.2,0,0.4-0.1,0.5C152.1,130.3,152,130.3,151.9,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.8,126.3h-9.2c-0.3,0-0.6-0.2-0.7-0.5l0,0c0-0.2,0.2-0.4,0.4-0.4h9.2c0.3,0,0.5,0.2,0.6,0.4l0,0 C167.2,126.1,167,126.3,166.8,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.2,128.3h-9.1c-0.3,0-0.6-0.2-0.7-0.5l0,0c0-0.2,0.1-0.5,0.3-0.5c0,0,0.1,0,0.1,0h9.1 c0.3,0,0.6,0.2,0.7,0.5l0,0C167.7,128,167.5,128.2,167.2,128.3C167.3,128.3,167.2,128.3,167.2,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.7,130.3h-9.2c-0.3,0-0.5-0.2-0.6-0.5l0,0c-0.1-0.3,0.1-0.5,0.3-0.5h9.2c0.3,0,0.6,0.2,0.7,0.5l0,0 C168.1,130,168,130.2,167.7,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.2,119.7l0.4,1.8c0.1,0.2,0,0.5-0.2,0.6c-0.1,0-0.1,0-0.2,0h-51.9c-0.4,0-0.7-0.3-0.8-0.6l-0.4-1.8 c-0.1-0.2,0-0.5,0.2-0.6c0.1,0,0.1,0,0.2,0h51.9C174.8,119.1,175.1,119.4,175.2,119.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.1,144.6h-4.6c-0.7,0-1.3-0.5-1.5-1.2l-2.3-8.9c-0.1-0.5,0.1-0.9,0.6-1.1c0.1,0,0.2,0,0.3,0h4.7 c0.7,0,1.2,0.5,1.4,1.1l2.3,8.9c0.2,0.4,0,0.9-0.4,1.1C155.3,144.6,155.2,144.6,155.1,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163,144.6h-4.6c-0.7,0-1.3-0.5-1.5-1.2l-2.3-8.9c-0.1-0.5,0.1-0.9,0.6-1.1c0.1,0,0.2,0,0.3,0h4.6 c0.7,0,1.3,0.5,1.5,1.1l2.3,8.9c0.2,0.4,0,0.9-0.4,1.1C163.3,144.6,163.2,144.6,163,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.8,144.6h-4.6c-0.7,0-1.3-0.5-1.5-1.2l-2.3-8.9c-0.1-0.5,0.2-1,0.8-1.1c0.1,0,0.1,0,0.2,0h4.6 c0.7,0,1.3,0.5,1.5,1.1l2.2,8.9c0.2,0.4,0,0.9-0.4,1.1C171.1,144.6,171,144.6,170.8,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146,144.6h-15.6c-1.2-0.1-2.1-0.9-2.4-2l-1.8-7.3c-0.3-0.8,0.1-1.6,0.9-1.9c0.2-0.1,0.4-0.1,0.6-0.1h15.6 c1.2,0.1,2.1,0.9,2.4,2l1.8,7.3c0.3,0.8-0.1,1.6-0.9,1.9C146.4,144.6,146.2,144.6,146,144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M142.9,136.1h-14.6c-0.2,0-0.5-0.2-0.5-0.4l0,0c-0.1-0.3,0.1-0.4,0.3-0.4h14.6c0.3,0,0.5,0.2,0.5,0.4l0,0 C143.4,135.9,143.2,136.1,142.9,136.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M132.4,138.1H129c-0.2,0-0.5-0.2-0.5-0.4l0,0c-0.1-0.3,0.1-0.4,0.3-0.4h3.5c0.2,0,0.5,0.2,0.5,0.4l0,0 C132.9,137.9,132.7,138.1,132.4,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183.4,166.7c0,0-5.5-2.2-7.3-2.4c-1.8-0.3-11.3,6.9-10.1,7.5c1.2,0.6,8.3-2.3,9.3-1.6s1.9,1.5,2.9,1.5h4.5 L183.4,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M168.7,171.7c0,0,5.7-4.4,8.5-3s3.6,3,3.6,3H168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177.1,247.8c0,0-0.6,3.6-1.1,7c-0.5,3.5,0.9,7.4-0.3,7.4h-31.4c0,0,0.2-5.8,4.3-6.5s14.8-1.6,17.3-7.1 C168.5,243.2,177.1,247.8,177.1,247.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M284.5,262c-1.4,0-1.5-0.3-1.6-0.9l-4.2-29.5l-7.5-42.5l-2.1-11.9l5.4-0.2l1,6.8l6.5,48.5l3.8,28.8 C285.9,261.6,284.9,262,284.5,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M290.1,179.3H116.6c-2,0.1-3.7-1.4-3.9-3.4c0-0.1,0-0.3,0-0.4l0,0c-0.1-2,1.4-3.7,3.5-3.8c0.1,0,0.3,0,0.4,0 h173.5c2-0.1,3.7,1.4,3.9,3.4c0,0.1,0,0.3,0,0.4l0,0c0.1,2-1.4,3.7-3.5,3.8C290.4,179.3,290.3,179.3,290.1,179.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M255.2,180.1h-0.3c-0.3-1.1-1-2-2-2.5c-7.9-4.5-22.6,0.4-22.6,0.4s-49.2,6-53.7,12.4s-10.7,57.1-10.7,57.1 s8.5,1.1,12-0.2c0,0,12.9-27.5,12.6-38.1c0-0.9,0.6-5.7,1.1-5.7c8.9-0.5,31.2-0.5,39.8-1.1c7-0.2,17.9-0.7,21-1.7 C256.8,199.2,255.2,180.1,255.2,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234.9,118.3l-1.7,8.2l-7.7,0.4c-0.1-0.8,0.9-4.4,0.6-7.1c-0.3-1.6-1-3.1-2.1-4.2l8.7-6.5 c0,0.1,1.6,1.9,1.6,2.3C235.4,117.5,234.9,118.3,234.9,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M224.4,119.7c0.2-0.1,10-2.9,11.1-2.4c1,0.4,2.9,2.8,2.9,2.8l-16.5,2.3C222.3,121.1,223.2,120.1,224.4,119.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M222.3,116.4c0,0,12.6,1.1,12.9-7c0.3-8.1,2.1-13.5-6.2-14.2c-8.3-0.7-10,2.3-10.7,5c-0.2,0.6-1,1.6-1,3 c0.1,1.5,0.8,1,0.9,2.1c0.1,1-0.8,2.3-0.6,2.9C218.2,112.1,220.5,116.3,222.3,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M218.6,99.4c0,0,3.7,8.9,4.3,7.1c0.6-1.8,2.2-4.1,4,1.7c0.2,0.6-0.6,3,0,2.7s1.7,0.3,3.6,1.9 c1.9,1.6,3.2,0.2,4.9-0.8c6.4-3.6,5.5-16.4,3.4-18.9c-2.1-2.5-13.3-2.9-18.5-1.4C217.3,92.6,215,96.3,218.6,99.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.9,181.7c-2.8,3.3-25.6,1.6-32.5-1c-0.5-0.3-1-1.2-1.3-1.5c-0.3-0.3,8.7-2.1-5.1-30.6l0,0 c-7.3-17.6,0.4-23.3,5.3-26.2l7.8-1.6c4.1-0.8,8.6-1.6,12,0.3C254.3,128.9,257.8,178.2,254.9,181.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M230.9,172c-0.4,3.4,0.5,11.6-8.6,8.7c-0.5-0.3-2.4-1.8-2.6-3.6c-0.3-3.6,3-3,3-3s-2.6-0.1-1-7.4 c0.1-0.4-2.7-9.3-2.7-9.7c-0.1-4.2,0.6,0.7-3.1-8.3l0,0c1.6-1.2,4.4-2.5,6.2-0.4C224,150.2,231.5,168.5,230.9,172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,121.8c0,0-10.1,0.9-11.9,7.9c-0.4,2-0.6,6.7-1.4,12c-1,7-1.7,1.4-5.8,15.2c-0.3,0.8-0.4,2.2-1.4,2.3 s-10.1,4.5-11.3,4.9l-5.1,1c-0.8,0.1-6.8,1.2-5.2,6.5h28.5c2.5-3,4.6-6.3,6.2-9.8c2.3-4.9,3.5-11,5.6-13.9 C234.6,132.5,227.8,119.3,224.8,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.9,201.7h-64.6c0,0,1.6-5.7,39.8-4.9C264.2,197.4,261.9,201.7,261.9,201.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M192.3,262.5c7.6-35.5,5.7-57.3,5.6-57.5c-0.1-0.3,1.1-1,1.7-1.1c0.6-0.1,3.2-0.1,3.6,0.3 c0.3,0.4,1.4,27-8.7,58.3H192.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M253.9,262.5c-7.7-35.5-5.7-57.3-5.7-57.5c0-0.3-1-1-1.6-1.1c-0.6-0.1-3.3-0.1-3.6,0.3 c-0.3,0.4-1,28.4,7.7,58.3H253.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M261.6,135.9c-8.3-0.1-10.6,3.7-10.8,4.6c-0.3,0.9-1.7,6.2-3.7,16.8c-1.5,9-2.4,18.1-2.8,27.2 c-0.5,5.2-0.7,10.4-0.7,15.7h-46.9c-0.4-0.1-0.8,0.3-0.9,0.7c0,0.1,0,0.1,0,0.2v2.6c0,0.5,0.3,1.6,0.9,1.6h64.2 c0.4,0,0.9-1.1,0.9-1.6v-2.6c0-0.1-0.1-0.3-0.1-0.3c-0.3-33.3,7.3-59,7.4-59.3c0.1-0.1,0.1-0.3,0.1-0.4 C269.1,141,269.9,136.1,261.6,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M240.5,129.5c1.6,5.4,1.5,10.8,0.4,16.3c-0.1,0.3,0.5,0.4,0.6,0.1c1.5-5.4,0.9-11.2-0.7-16.5 C240.7,129.2,240.4,129.3,240.5,129.5L240.5,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M241.4,128.9c1.3,4.2,2.3,8.4,3.2,12.6c0.2,0.4,0.9,0.2,0.8-0.3c-1-4.2-2.2-8.4-3.6-12.5 c0-0.1-0.1-0.2-0.2-0.1S241.4,128.8,241.4,128.9L241.4,128.9L241.4,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M222.3,174c2.4,1.8,5.4,2.7,8.4,2.3l5.1-0.8c0.9,0,1.8,0,2.7,0.2c0.8,0.2,1.7,0.5,2.4,0.9 c0.3,0.1,0.7-0.2,0.4-0.4c-2.3-1.8-5.9-1.2-8.4-0.8c-1.8,0.4-3.7,0.5-5.6,0.3c-1.8-0.3-3.4-1-4.9-2 C222.4,173.7,222.1,173.9,222.3,174L222.3,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M229.8,183.1c-0.7,0.8-1.3,1.6-1.8,2.4c-0.3,0.7-0.3,1.6,0,2.3c0.4,0.8,0.7,1.7,0.7,2.6c-0.2,1-0.4,2-0.9,2.9 c-0.3,0.5,0.7,0.8,1,0.3c0.3-0.5,1.2-3.5,0.4-5.3c-0.8-1.8-0.9-1.6-0.4-2.5l1.7-2.3C230.9,183.1,230.2,182.7,229.8,183.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M209.2,195.7c5.5-0.9,10.8-1.9,16.2-3.2c2.1-0.4,4-1.3,5.7-2.6c0.9-0.8,1.7-1.6,2.5-2.4 c0.3-0.5,0.7-0.8,1.2-1c0.5,0,1,0,1.5,0.1c0.4,0,0.6-0.5,0.3-0.7s-2.8-0.5-4.1-1.1v0.9c1.1-0.2,1.9-0.9,2.4-1.9 c0.3-0.5-0.5-1-0.8-0.4c-0.4,0.7-1.1,1.2-1.9,1.4c-0.3,0.1-0.4,0.4-0.3,0.7c0,0.1,0.1,0.1,0.1,0.2c1.4,0.7,2.9,0.3,4.2,1l0.3-0.7 c-0.8-0.1-1.5-0.1-2.3,0.2c-0.8,0.3-1.4,1.4-2,2c-1.8,1.8-4,3.2-6.5,3.8c-5.5,1.4-11,2.6-16.5,3.6 C209,195.4,209.1,195.7,209.2,195.7L209.2,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M234.1,173.3l4.4-0.2c0.6,0,1.2,0,1.8,0l0.7,0.2l0.7,0.4c0.2,0.1,0.3,0,0.3-0.2s-0.7-0.8-1.1-0.9 c-0.6-0.1-1.2-0.1-1.8-0.1l-5,0.3C233.9,172.9,233.9,173.3,234.1,173.3L234.1,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M191.2,197.1c0.4,1.3,0.5,2.8,0.3,4.2c-0.1,0.7-0.3,1.4-0.5,2c-0.3,0.7-0.7,1.3-1,2c-0.3,0.7,0.4,0.6,0.7,0.3 c0.5-0.6,0.8-1.3,1-2c0.3-0.7,0.4-1.4,0.5-2.2c0.2-1.5,0-3.1-0.5-4.5C191.7,196.6,191,196.7,191.2,197.1L191.2,197.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M189.1,198.5c1.4,6.4,0.4,13.1-1.1,19.3c-1.9,6.7-4.1,13.2-6.8,19.6c-1.3,3.3-2.6,6.5-3.8,9.9 c-0.3,0.7,0.9,1,1.1,0.3c4.5-12.6,11-25,12.3-38.6c0.3-3.6,0.2-7.1-0.5-10.7C190.1,197.6,188.9,197.9,189.1,198.5L189.1,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166.8,171.6c0.5,0.2,1.1,0.3,1.6,0.3h10c1.4,0.1,2.8,0.1,4.2-0.1c0.3,0,0.6-0.6,0.2-0.7 c-1.4-0.1-2.8-0.1-4.2,0h-10.2c-0.6,0-1.1,0-1.6,0.2v0.2V171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166.2,248.4c3.9,0,7.9,0.2,11.8-0.6c0.5-0.2,0.3-0.9-0.3-0.8c-1.9,0.3-3.8,0.5-5.8,0.6h-5.6 C165.8,247.8,165.7,248.4,166.2,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166,247.9c-1.4,1.7-3,3.2-4.9,4.3c-0.8,0.6-1.7,1.1-2.7,1.6c-1.3,0.4-2.7,0.7-4.2,0.8 c-2.6,0.3-5.8,0.1-7.9,1.8c-2.1,1.7-2.3,3.8-2.2,6.1c0.1,0.5,1,0.5,1,0c-0.3-2.9,0.8-5.6,3.8-6.3c3-0.7,5.7-0.6,8.5-1.2 c1.9-0.6,3.7-1.5,5.2-2.8c1.6-1,2.9-2.4,4-3.9C166.9,247.8,166.2,247.5,166,247.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M176.6,248.3c0.5,1.3-0.1,2.6-0.5,3.9c-0.2,1-0.4,2.1-0.3,3.1c0.1,2.3,0.7,4.6,0,6.8c-0.2,0.5,0.8,0.7,0.9,0.2 c0.8-2.3,0.2-4.6,0.1-6.9c-0.1-1.2,0.1-2.4,0.4-3.6c0.6-1.1,0.6-2.4,0.3-3.6C177.2,247.7,176.5,247.8,176.6,248.3L176.6,248.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.7,156.7c-1,1.4-1.8,3-2.4,4.7c-0.6,1.6-0.9,3.4-0.8,5.1c0.1,0.2,0.3,0.2,0.5,0.1c0.1,0,0.1-0.1,0.1-0.1 c0.2-0.8,0.2-1.6,0.3-2.4c0.1-0.9,0.3-1.7,0.6-2.5c0.5-1.6,1.2-3.2,2.1-4.6C206.4,156.6,205.9,156.4,205.7,156.7L205.7,156.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.7,171.7c0.1-2.2,0.4-4.8,2.7-5.6c2.3-0.9,4.6-1,6.8-1.5c2-0.4,4-1.2,5.8-2.3c1.9-1.2,3.8-2.6,6.2-2.5 c0.5,0.1,0.5-0.6,0-0.7c-2.3,0-4.2,1.1-6.1,2.3c-2.3,1.4-4.9,2.3-7.5,2.7c-2.2,0.4-5.1,0.5-6.8,2.1c-1.7,1.6-1.6,3.6-1.5,5.5 C182.3,171.8,182.5,171.8,182.7,171.7C182.6,171.7,182.7,171.7,182.7,171.7L182.7,171.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M183,171.8c4.7,0.3,9.4,0.1,14.2,0.1s9.5,0.2,14.2,0c0.3-0.1,0.4-0.6,0-0.6c-4.7-0.2-9.4-0.1-14.2-0.1 s-9.5-0.2-14.2,0.2C182.6,171.3,182.6,171.8,183,171.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221.7,166.3c0.3,1.8-0.8,3.4-0.7,5.1c0.1,1.2,0.7,2.3,1.8,2.9l0.3-0.7c-1-0.1-2.3-0.2-2.9,0.8 c-0.3,0.5-0.4,1.1-0.3,1.7c-0.2,0.7-0.2,1.5-0.2,2.3c0.1,1,1,1.5,1.6,2c1.1,0.8,2.4,1.4,3.8,1.6c4.6,1.1,9.5,1.2,14.3,1.5l4.9,0.2 c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4c-4-0.1-8.4-0.4-12.5-0.8c-2.5-0.1-4.9-0.5-7.3-1.1c-1.2-0.4-3.2-1.2-3.9-2.3 c-0.2-0.8-0.2-1.7,0-2.5c0.1-0.7,0-1.4,0.8-1.7c0.5-0.1,1-0.1,1.5-0.1c0.3,0.1,0.7-0.3,0.3-0.6c-2.8-1.7-0.5-5.1-1.1-7.5 C222.1,166,221.7,166.1,221.7,166.3L221.7,166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.8,106.5c0-0.6,0-1.8,0.9-1.9c0.9-0.1,1.4,1.3,1.6,2c0.3,0.9,0.5,1.9,0.5,2.9c0.1,0.5,0,0.9-0.2,1.4 c-0.2,0.4-0.4,0.7-0.7,1c-0.2,0.3,0.2,0.4,0.4,0.3c0.3-0.1,1.2-2,1.2-2.9s-0.3-1.4-0.3-2c-0.1-0.6-0.3-1.2-0.5-1.8 c-0.4-0.9-1.4-1.8-2.4-1.4s-1,1.5-0.9,2.3C223.4,106.6,223.6,106.6,223.8,106.5C223.7,106.5,223.7,106.5,223.8,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.9,92.3c-1.2,0.9-2,2.2-2.3,3.6c-0.1,0.6,0,1.3,0.3,1.9c0.2,0.6,0.7,1.1,1.3,1.3c1,0.5,1,1.7,1.3,2.7 l1,2.8c0.4,1,1.4,2.7,2.9,2.3c1.5-0.4,0.4-0.5,0-0.6c-0.7,0-1.4-0.4-1.7-1c-0.4-0.7-0.7-1.4-1-2.2c-0.3-0.7-0.5-1.5-0.7-2.3 c-0.1-0.6-0.3-1.2-0.7-1.6c-0.3-0.5-1-0.6-1.5-1c-0.4-0.5-0.6-1.1-0.5-1.7c0-1.5,0.7-2.8,1.9-3.7C219.5,92.4,219.2,92.2,218.9,92.3 L218.9,92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219,92.9c1.6-1.4,4.2-1.3,6.2-1.5c2-0.2,3.9-0.4,5.9-0.3c3.3,0.1,7.4,0.2,8.4,3.9c1,3.7,1.4,7.6,0.3,11.1 c-0.5,1.5-1.3,2.9-2.3,4.2c-1.1,1-2.4,1.8-3.7,2.4c-0.3,0.1-0.2,0.5,0.2,0.5c2.4-0.3,4.5-2.5,5.6-4.5c1.4-2.8,1.9-6,1.5-9.1 c-0.3-2.5-0.4-6.1-2.8-7.7c-2.3-1.6-5.7-1.5-8.4-1.5c-2.2,0-4.4,0.2-6.6,0.5c-1.7,0.2-3.3,0.3-4.6,1.6S218.8,93,219,92.9L219,92.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.7,111.1c0.7-0.5,1.4,0.5,1.6,1c0.3,0.6,0.9,1,1.6,1.2c0.6,0.2,1.2,0.2,1.8,0.1c0.7-0.1,1.3-0.3,1.9-0.7 c0.3-0.3,0-0.5-0.3-0.4c-0.3,0.1-1.3,0.4-2,0.5c-0.7,0.1-1.4,0-1.9-0.4c-0.6-0.4-0.9-1.1-1.5-1.5c-0.5-0.4-1.1-0.4-1.6-0.1 C227,111,227.4,111.2,227.7,111.1L227.7,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.3,116.4L224.3,116.4l0.1,0.2l0.3,0.3l0.5,0.9l0.4,0.9l0.3,0.4l0.3,0.3c0.1,0.2,0.4,0,0.4-0.2 c-0.1-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.3-0.2-0.4l-0.5-1c-0.3-0.6-0.8-1.1-1.3-1.5C224.2,115.7,223.8,116.2,224.3,116.4 L224.3,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M235.5,111.8c-1,0.2-1.3,1.3-1.2,2.3c0.1,0.6,0.2,1.1,0.3,1.6c0.1,0.3,0.1,0.6,0.2,0.9 c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.3,0.7,0.1,0.6-0.3c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.3-0.1-0.4-0.2-0.7c-0.2-0.5-0.3-0.9-0.3-1.4 c-0.1-0.7-0.3-1.8,0.6-2.1C236.6,112.1,236,111.8,235.5,111.8L235.5,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222.5,122.4c0.1-1.4,1.4-1.9,2.5-2.3c1.1-0.4,2.3-0.8,3.6-1c2.3-0.7,4.6-1.2,7-1.5c0.4-0.1,0.3-0.7-0.2-0.7 c-2.8,0.4-5.5,1.1-8.2,1.9c-1.9,0.5-5.3,1.2-5.3,3.6C221.8,122.8,222.5,122.8,222.5,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222.5,122.7c4.3-0.9,8.7-2,13.2-2.4c0.7-0.1,4.2,0.2,2.9-1.4s-2.7-2.6-4.2-1.6c-0.1,0.1-0.2,0.3,0,0.5 c0.1,0.1,0.1,0.1,0.2,0.1c0.8-0.1,1.6,0.1,2.3,0.5c0.4,0.2,0.7,0.5,1,0.9c0.3,0.3,0.3,0.1-0.1,0.2h-0.8c-1.7,0.1-3.4,0.3-5.1,0.6 l-5.2,1C225.4,121.4,223.5,121.5,222.5,122.7L222.5,122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.5,122.2c-5.8-0.3-10.4,4.1-11.3,9.6c-0.5,3.3-0.2,6.8-0.9,10c-0.5,1.7-1.2,3.4-2,5 c-0.8,1.5-1.4,3.1-1.9,4.7c-1.2,3.9-2,8-2.4,12c-0.1,0.5,0.8,0.5,0.8,0c0.8-4.4,1.5-8.9,2.9-13.2c0.7-1.8,1.5-3.6,2.3-5.4 c0.8-1.7,1.3-3.6,1.5-5.5c0.3-3.9-0.2-8.1,1.9-11.7c2-3.1,5.4-5,9.1-5.1C223.8,122.7,223.8,122.2,223.5,122.2L223.5,122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M238.4,120.3c3.4,1.9,6.3,4.6,8.3,8c1,1.7,1.8,3.5,2.3,5.4c0.6,1.9,1,4,1.7,5.8c0.1,0.4,0.8,0.3,0.7-0.2 c-1.6-7.7-5.1-16.1-12.7-19.5C238.4,119.6,238,120.2,238.4,120.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227,139.6c-0.3,1.6-0.9,3.1-1.6,4.6c-0.8,1.2-1.7,2.3-2.6,3.6c-0.9,1.2-2.3,5.4-3.1,8.1 c-1.9,5.6-4.7,10.8-8.5,15.4c-0.3,0.3,0.3,0.8,0.5,0.4c3.8-4.5,6.6-9.6,8.5-15.2c1-3.1,1.6-6.2,3.6-8.9c2-2.7,3.3-4.9,3.7-8 C227.4,139.5,227,139.5,227,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219.1,157.8c0.4,1.1,0.7,2.2,0.9,3.4c0.1,1.4,0.4,2.8,0.8,4.2c0.5,1.3,1.5,2.3,2.7,2.9l1.9,0.7l2.5,1 c0.3,0.2,0.9-0.3,0.4-0.5c-0.4-0.3-2.6-1.1-3.9-1.6c-1.4-0.5-2.4-1.6-2.9-3c-0.4-1.3-0.7-2.6-0.8-4c-0.3-1-0.8-2.1-1.1-3.1 C219.2,156.6,219.1,157.6,219.1,157.8L219.1,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M232.2,114.3l1.5-0.3l1.4-0.6c0.1-0.1,0.2-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2,0-0.2,0.1l-1.3,0.5 l-1.4,0.4C231.9,114,232,114.4,232.2,114.3L232.2,114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M220,178.9c-7.1,1.7-14.4,2.7-21.6,4.1c-3.6,0.7-7.1,1.5-10.7,2.5l-5.1,1.7c-1.6,0.6-3.2,1.2-4.7,2.1 c-2.3,1.5-3.6,4.2-4.2,6.8s-1.2,5.6-1.6,8.4c-1.2,7.5-2.5,15.1-3.7,22.5c-0.7,4.3-1.3,8.7-2,12.9c-0.3,1.5-0.5,3.1-0.4,4.7 c0.1,1.1,0.1,2.3-0.1,3.4c-0.2,0.6,0.8,0.8,0.9,0.3c0.2-1,0.3-2.1,0.3-3.1c-0.2-0.8-0.2-1.7,0-2.5c0.4-3.7,1-7.4,1.6-11.2 c1.1-7.3,2.4-14.6,3.6-21.8c0.6-3.4,1.1-6.8,1.7-10.1s1.1-5.5,2.9-7.8c1.7-2.3,2.7-2.1,4.3-2.9c1.7-0.7,3.4-1.4,5.2-1.9 c3.3-1.1,6.8-2,10.2-2.7c7.9-1.6,15.9-2.6,23.7-4.4C220.9,179.6,220.6,178.8,220,178.9L220,178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.2,99.1c0.3,1.7-1.6,3.1-1,4.9c0.2,0.4,0.4,0.8,0.5,1.3c0.2,0.7-0.2,1.2-0.3,1.9c-0.1,0.9,0.1,1.8,0.5,2.6 l1.3,3.3c0.3,0.9,0.7,1.8,1.3,2.5c1.1,1.3,2.9,1.5,4.3,0.6c0.3-0.2,0-0.7-0.3-0.5c-0.8,0.5-1.8,0.5-2.7,0.1 c-0.8-0.6-1.5-1.5-1.7-2.5l-1.2-2.9c-0.3-1-1-2-0.9-3c0.3-0.6,0.4-1.3,0.4-2c-0.1-0.9-0.8-1.6-0.7-2.5c0.1-1,1.3-2.5,1-4 S218.1,98.8,218.2,99.1L218.2,99.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 109.7,
    cy: 73.9,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 97.4,
    cy: 76.5,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M113,87.6c2.7,3.9,8.6-0.2,5.9-4.1C116.2,79.6,110.3,83.7,113,87.6z M117.2,84.6c1.2,1.6-1.5,3.6-2.6,1.8 C113.5,84.7,116.1,82.9,117.2,84.6L117.2,84.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 206.7,
    cy: 64.8,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 160.8,
    cy: 82.8,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M195.1,60.8c2.8,3.8,8.7-0.3,6-4.2S192.4,56.9,195.1,60.8z M199.4,57.8c1.2,1.7-1.5,3.6-2.6,1.9 c-0.4-0.8,0-1.8,0.8-2.2C198.2,57.2,198.9,57.3,199.4,57.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 102.2,
    cy: 39.2,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 129,
    cy: 52.7,
    r: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M127.9,44.4h2.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 129,
    y1: 47.6,
    x2: 129,
    y2: 44.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M121,49.2l0.4-0.9l0.5-0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 124.1,
    y1: 49.9,
    x2: 121.4,
    y2: 48.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M121.5,57.3l-0.5-0.9c-0.2-0.3-0.3-0.6-0.4-1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 123.7,
    y1: 54.8,
    x2: 121,
    y2: 56.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M130,61.3h-2.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 129,
    y1: 58.2,
    x2: 129,
    y2: 61.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M137.5,55.9l-0.5,1l-0.5,0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 134.3,
    y1: 55.3,
    x2: 137,
    y2: 56.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M136.4,47.5l0.5,0.9l0.5,0.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 134.3,
    y1: 49.9,
    x2: 137,
    y2: 48.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 205.7,
    cy: 79.1,
    r: 2.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 205.7,
    y1: 76,
    x2: 205.7,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 202.8,
    y1: 77.4,
    x2: 201.1,
    y2: 76.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 202.5,
    y1: 80.3,
    x2: 200.9,
    y2: 81.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 205.7,
    y1: 82.4,
    x2: 205.7,
    y2: 84.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 208.9,
    y1: 80.6,
    x2: 210.6,
    y2: 81.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 208.9,
    y1: 77.4,
    x2: 210.6,
    y2: 76.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M80,68.9c6.2,0.7,7.4-8.8,1.1-9.6C74.8,58.5,73.6,68.1,80,68.9z M80.7,61.9c2.8,0.3,2.3,4.6-0.5,4.2 C77.4,65.8,78,61.6,80.7,61.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 68.7,
    cy: 58,
    r: 1.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomOccupancy);
export default __webpack_public_path__ + "static/media/room-occupancy.782c04b51d394eaf7be11901b1c86e97.svg";
export { ForwardRef as ReactComponent };